import React from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import RowGroup from '../row-group';

import {
  Column,
  Container,
  Table,
  Title,
  Row,
  Body,
} from './styles';

const GroupsTable = (props) => {
  const {
    handleOpenEditModal,
    grouped,
    handleOpenModalDelete,
  } = props;

  const handleEdit = (currrent) => {
    handleOpenEditModal(currrent);
  };

  return (
    <Container>
      <Table basic="very">
        <Body>
          <Row>
            <Column borderbottom>
              <Title marginleft>
                Name
              </Title>
            </Column>
            <Column borderbottom width={9}>
              <Title>
                Description
              </Title>
            </Column>

            <Column borderbottom width={2} />

          </Row>

          {grouped && _.map(grouped, (template, index) => {
            const noBorderFirstIndex = index === 0;

            return (

              <RowGroup
                id={template.id}
                noBorderFirstIndex={noBorderFirstIndex}
                name={template.name}
                description={template.description}
                handleEdit={() => handleEdit(template.id)}
                handleDelete={handleOpenModalDelete}
              />

            );
          })}
        </Body>
      </Table>

    </Container>
  );
};

GroupsTable.propTypes = {
  grouped: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  handleOpenEditModal: PropTypes.func.isRequired,
  handleOpenModalDelete: PropTypes.func.isRequired,
};

export default GroupsTable;
